import { useContext, useState } from "react";
import { AiFillDashboard, AiOutlineLogout } from "react-icons/ai";
import { MdBedroomParent, MdBookOnline, MdInventory2, MdRateReview } from "react-icons/md";
import { FaRegCalendarAlt } from "react-icons/fa";
import { RiPriceTag3Line, RiCalendarCheckLine } from "react-icons/ri";
import Dashboard from "../components/Dashboard/Dashboard";
import Inventory from "../components/Inventory/InventoryPage";
import Calendar from "../components/Calendar";
import Reservations from "../components/Reservations/Reservations";
import TarifsPage from "../components/Tarifs/TarifsPage";
import Rooms from "../components/Rooms/Rooms";
import ReviewsModeration from "../components/Reviews/ReviewsModeration";
import Cookies from "js-cookie";
import { AuthAdminContext } from "../../clients/utils/AuthAdminContext";
import "./Admin.css";
import { Link } from "react-router-dom";
import Book from "../components/Book";

export default function Admin() {
  const [activePage, setActivePage] = useState("dashboard");
  const { dispatch } = useContext(AuthAdminContext);
  const [needRatePlanMsg, setNeedRatePlanMsg] = useState(false);

  const renderPage = () => {
    switch (activePage) {
      case "inventory":
        return <Inventory setActivePage={setActivePage} />;
      case "rooms":
        return <Rooms setActivePage={setActivePage} setNeedRatePlanMsg={setNeedRatePlanMsg} />;
      case "tarifs":
        return (
          <TarifsPage
            needRatePlanMsg={needRatePlanMsg}
            setNeedRatePlanMsg={setNeedRatePlanMsg}
            setActivePage={setActivePage}
          />
        );
      case "book":
        return <Book />;
      case "calendar":
        return <Calendar />;
      case "reservations":
        return <Reservations />;
      case "reviews":
        return <ReviewsModeration />;
      default:
        return <Dashboard />;
    }
  };

  return (
    <div className="admin-wrapper">
      <div className="admin-container">
        {/* SIDEBAR */}
        <div className="sidebar">
          <div className="logo">Komorotel</div>

          <div className="menu">
            {[
              { key: "dashboard",    icon: <AiFillDashboard /> },      // Vue globale
              { key: "rooms",        icon: <MdBedroomParent /> },      // Chambres
              { key: "inventory",    icon: <MdInventory2 /> },         // Disponibilités
              { key: "tarifs",       icon: <RiPriceTag3Line /> },      // Tarifs              
              { key: "reservations", icon: <RiCalendarCheckLine /> },  // Consulter réservations
              { key: "book",         icon: <MdBookOnline /> },         // Créer réservation manuelle
              { key: "reviews",      icon: <MdRateReview /> },         // Avis
            ].map((item) => (
              <div
                key={item.key}
                className={`menu-item ${activePage === item.key ? "active" : ""}`}
                onClick={() => setActivePage(item.key)}
              >
                {item.icon}
              </div>
            ))}
          </div>

          <Link
            to="/"
            className="menu-item"
            onClick={() => {
              dispatch({ type: "ADMIN_LOGOUT" });
              Cookies.remove("admin_token", {
                path: "/",
                domain: ".komorotel.com",
              });
            }}
          >
            <AiOutlineLogout />
          </Link>
        </div>

        {/* MAIN */}
        <div className="main">
          <div className="content">{renderPage()}</div>
        </div>
      </div>
    </div>
  );
}